export function useLocalize() {
  const { i18n } = useTranslation();
  const lang = i18n.language.startsWith('zh') ? 'zh' : 'en';
  return (obj: object, field: string): string => {
    const r = obj as Record<string, unknown>;
    return (r[`${field}_${lang}`] as string) || (r[field] as string) || '';
  };
}
